import { tooInsurancePurchaseSteps } from '../../constants/tooInsurance';
import { uuid } from './regex';

export const TooResidentialRoutes = {
    path: 'too',
    details: {
        path: `:insuranceId(${uuid})`,
        purchase: {
            path: 'purchase',
            step: {
                path: `:step(${tooInsurancePurchaseSteps.join('|')})`,
            },
        },
        installments: {
            path: 'installments',
        },
        coverages: {
            path: 'coverages',
        },
        fail: {
            path: 'fail',
        },
    },
};
